
















































































































































































































































































































































































































import {
	defineComponent,
	computed,
	Ref,
	ref,
	nextTick,
} from '@vue/composition-api';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SortableEvent } from 'sortablejs';
import cloneDeep from 'clone-deep';
import deepEqual from 'deep-equal';
import Draggable from 'vuedraggable';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FullWidthListSection from '@front-app/modules/group/highlights/components/FullWidthList/FullWidthListRender.vue';
import { canViewPinnedHighlights } from '@front-app/util/permission';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import {
	AnyHighlightChildRequest,
	HighlightsContainerRequest,
	HighlightsContainerResponse,
	SectionType,
} from '@front-app/modules/group/highlights/model';
import { performDelete } from '@front-app/modules/group/highlights/util/delete';
import { createHighlights, createSection } from '@front-app/modules/group/highlights/util/create';
import { cloneElement, cloneSection } from '@front-app/modules/group/highlights/util/clonePlaceholder';
import { moveExternal, moveInternal } from '@front-app/modules/group/highlights/util/draggable';
import {
	areSame,
	findItemById,
	hasAnyEmptySections,
	isEmptyHighlights,
} from '@front-app/modules/group/highlights/util/compare';
import {
	COMPONENTS_BY_TYPE,
	SECTIONS_BY_TYPE,
} from '@front-app/modules/group/highlights/util/componentsByType';
import {
	ELEMENT_PLACEHOLDERS,
	SECTION_PLACEHOLDERS,
} from '@front-app/modules/group/highlights/util/adminComponentsByType';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { Size, Spacing } from '@front-app/components/constants';
import Vue from '@front-app/vendor/vue';
import { validateItem } from '@front-app/modules/group/highlights/util/validate';
import EditWrapper from '@front-app/modules/group/highlights/components/EditWrapper.vue';
import { useGroupsCustomHighlights } from '@front-app/store/modules/highlights';
import { Routes } from '@front-app/constants/routes';
import { mergeObjects } from '@front-app/util/object';
import BackButton from '@front-app/components/buttons/BackButton.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import ContactUsLink from '@front-app/components/ContactUsLink.vue';
import { sleep } from '@front-app/util/async';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { usePreventWindowClose } from '@front-app/hooks/usePreventWindowClose';
import LastUpdateLoader from '@front-app/components/LastUpdateLoader.vue';
import isAfter from 'date-fns/isAfter/index';
import { useConfirmDialog } from '@vueuse/core';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import { SlideFrom } from '@front-app/components/modals/slidingPanelModel';
import { isHighlightsSection, isNew, isUnfilledButton } from '@front-app/modules/group/highlights/util/model';
import ErrorFeedback from '@front-app/modules/group/highlights/components/ErrorFeedback.vue';
import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import TrModal from '@front-app/components/modals/TrModal.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EditorPanel from '@front-app/modules/group/highlights/components/EditorPanel.vue';
import WarningCard from '@front-app/components/cards/state/WarningCard.vue';

function getInitialState() {
	return [createHighlights([createSection(SectionType.FULL_WIDTH_LIST)])];
}

export default defineComponent({
	components: {
		ScrollingColumn,
		ColumnContainer,
		ColumnHeader,
		Draggable,
		ErrorCard,
		FullWidthListSection,
		CtaButton,
		EditWrapper,
		BackButton,
		PaddedContent,
		LoaderState,
		ContactUsLink,
		LastUpdateLoader,
		ConfirmationModal,
		SlidingPanel,
		ErrorFeedback,
		XButton,
		TrModal,
		FontAwesomeIcon,
		EditorPanel,
		WarningCard,
	},
	// Once we move to Vue3 we can use the onBeforeRouteLeave hook
	beforeRouteLeave(to, from, next) {
		const { off: offConfirm } = this.confirmUnsavedModal.onConfirm(() => {
			offConfirm();
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			offCancel();
			next();
		});
		// eslint-disable-next-line no-var
		const { off: offCancel } = this.confirmUnsavedModal.onCancel(() => {
			offConfirm();
			offCancel();
		});
		if (this.hasUnsavedUpdates) {
			this.confirmUnsavedModal.reveal();
		} else {
			next();
		}
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const addElementsPanel = useConfirmDialog();
		const editElementsPanel = useConfirmDialog();

		// Change tracking
		const lastEditTime = ref(new Date());

		// Initial setup
		const {
			track,
			isError: groupLoadingFailed,
			isLoading: pageIsLoading,
		} = useAsyncStatus();
		track(GroupsStore.getInstance().fetchGroupsOnce());

		const editState: Ref<HighlightsContainerRequest[]> = ref(getInitialState());
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasHighlightsAccess } = useAdminAccess(group);
		const areHighlightsEnabledForGroup = computed(() => canViewPinnedHighlights(group.value));

		// Highlights state
		const afterFetch = (highlightsContainers: HighlightsContainerResponse[]) => {
			let overallLastModifiedDateTime = lastEditTime.value;
			highlightsContainers.forEach((container) => {
				if (isAfter(overallLastModifiedDateTime, new Date(container.lastModifiedDateTime))) {
					overallLastModifiedDateTime = new Date(container.lastModifiedDateTime);
				}
			});
			lastEditTime.value = overallLastModifiedDateTime;

			if (isEmptyHighlights(highlightsContainers)) {
				editState.value = getInitialState();
			} else {
				const containerContents: HighlightsContainerRequest[] = [];
				highlightsContainers.forEach((container) => {
					const {
						// eslint-disable-next-line @typescript-eslint/no-unused-vars
						createdDateTime,
						// eslint-disable-next-line @typescript-eslint/no-unused-vars
						lastModifiedDateTime,
						...rest
					} = cloneDeep(container);
					containerContents.push(rest);
				});
				editState.value = containerContents;
			}
		};
		const {
			highlights,
			update: updateHighlights,
		} = useGroupsCustomHighlights(computed(() => props.groupId), afterFetch);
		afterFetch(highlights.value);

		// Errors
		const showElementErrors = ref(false);
		const hasAnyElementErrors = computed(() => editState.value
			.flatMap(({ sections }) => sections)
			.flatMap(({ elements }) => elements)
			.some((el) => validateItem(el).length > 0));

		// Selecting items for editing
		const selectedItem: Ref<AnyHighlightChildRequest | undefined> = ref(undefined);
		const selectItem = (item: AnyHighlightChildRequest) => {
			selectedItem.value = item;
			// For now, there's nothing to edit in a section
			if (isHighlightsSection(item)) {
				return;
			}
			addElementsPanel.cancel();
			editElementsPanel.reveal();
			if (!hasAnyElementErrors.value) {
				showElementErrors.value = false;
			}
		};
		const isSelectedItem = (item: AnyHighlightChildRequest) => {
			if (!selectedItem.value) {
				return false;
			}
			return areSame(selectedItem.value, item);
		};
		const updateSelection = (updatedItem: AnyHighlightChildRequest) => {
			const item = editState.value
				.flatMap(({ sections }) => sections)
				.flatMap(({ elements }) => elements)
				.find((i: AnyHighlightChildRequest) => areSame(updatedItem, i));

			if (!item || item.type !== updatedItem.type || deepEqual(item, updatedItem)) {
				return;
			}

			lastEditTime.value = new Date();
			mergeObjects(item, updatedItem);
		};
		const deleteChildModal = useConfirmDialog();
		const deleteSectionModal = useConfirmDialog();
		const deleteNewChildModal = useConfirmDialog();
		const deleteNewSectionModal = useConfirmDialog();
		const getDeleteModalForItem = (theItem: AnyHighlightChildRequest) => {
			if (SectionType.FULL_WIDTH_LIST === theItem.type) {
				return isNew(theItem) ? deleteNewSectionModal : deleteSectionModal;
			}
			return isNew(theItem) ? deleteNewChildModal : deleteChildModal;
		};
		const deleteItem = async (theItem: AnyHighlightChildRequest) => {
			const { isCanceled } = await getDeleteModalForItem(theItem).reveal();
			if (isCanceled) {
				return;
			}
			lastEditTime.value = new Date();
			editState.value.forEach((container) => {
				// eslint-disable-next-line no-param-reassign
				container.sections = performDelete(theItem, container);
			});
			selectedItem.value = undefined;
			closeEditElementsPanel();
		};
		const deleteSelection = () => {
			const theItem = selectedItem.value;
			if (!theItem) {
				return;
			}
			deleteItem(theItem);
		};
		const resetStatus = useAsyncStatus();

		const resetModal = useConfirmDialog();
		const reset = async () => {
			// So that users know that it is actually working we add a fake timer here
			await resetStatus.track(sleep(500));
			afterFetch(highlights.value);
			selectedItem.value = undefined;
			closeEditElementsPanel();
		};
		resetModal.onConfirm(reset);

		const emptySectionsModal = useConfirmDialog();
		const confirmSaveModal = useConfirmDialog();
		const confirmUnsavedModal = useConfirmDialog();
		const confirmIncompleteModal = useConfirmDialog();

		// This is a DOM ref and will be immediately available onMounts, so we can ignore
		// the `null` case
		const draggableItems = ref(null) as unknown as Ref<Vue>;

		const acknowledgeIncompleteElements = () => {
			confirmIncompleteModal.cancel();
			draggableItems.value.$el.querySelector('.element-error')?.scrollIntoView({ block: 'center' });
			const firstErrorElement = editState.value
				.flatMap(({ sections }) => sections)
				.flatMap(({ elements }) => elements)
				.find((item) => validateItem(item).length > 0);

			if (firstErrorElement) {
				selectItem(firstErrorElement);
			}
		};

		const submitStatus = useAsyncStatus();
		const submit = async () => {
			if (!group.value) {
				return;
			}
			if (hasAnyElementErrors.value) {
				confirmIncompleteModal.reveal();
				return;
			}
			if (hasAnyEmptySections(editState.value)) {
				const result = await emptySectionsModal.reveal();
				if (result.isCanceled) {
					return;
				}
			}
			const result = await confirmSaveModal.reveal();
			if (result.isCanceled) {
				return;
			}

			// Remove unused createdDateTime and lastModifiedDateTime object properties to avoid API error
			const payload = cloneDeep(editState.value);
			payload.forEach((container) => {
				// eslint-disable-next-line no-param-reassign
				delete container.createdDateTime;
				// eslint-disable-next-line no-param-reassign
				delete container.lastModifiedDateTime;
			});

			await submitStatus.track(updateHighlights(props.groupId, payload));
			editState.value = cloneDeep(highlights.value);
		};
		const focusClonedItem = async (e: SortableEvent) => {
			await nextTick();
			if (e.pullMode === 'clone' && e.newIndex !== undefined) {
				const id = (e.to.children[e.newIndex] as HTMLElement)?.dataset?.id;
				if (!id) {
					return;
				}
				let foundItemInHighlights;
				editState.value.forEach((container) => {
					const foundItemInContainer = findItemById(id, container.sections);
					if (foundItemInContainer) {
						foundItemInHighlights = foundItemInContainer;
					}
				});
				if (!foundItemInHighlights) {
					return;
				}
				selectItem(foundItemInHighlights);
			}
		};
		const hasUnsavedUpdates = computed(() => {
			let overallLastModifiedDateTime = lastEditTime.value;
			highlights.value.forEach((container) => {
				if (isAfter(overallLastModifiedDateTime, new Date(container.lastModifiedDateTime))) {
					overallLastModifiedDateTime = new Date(container.lastModifiedDateTime);
				}
			});
			return isAfter(lastEditTime.value, new Date(overallLastModifiedDateTime));
		});
		const onCancelledClose = () => {
			// eslint-disable-next-line no-alert
			window.alert(ctx.root.$t('highlights-admin.confirm-leave-unsaved'));
		};
		usePreventWindowClose(hasUnsavedUpdates, onCancelledClose);

		function closeEditElementsPanel() {
			if (selectedItem.value && isUnfilledButton(selectedItem.value)) {
				deleteSelection();
			}
			editElementsPanel.cancel();
			showElementErrors.value = true;
			selectedItem.value = undefined;
		}

		const openAddElementsPanel = () => {
			closeEditElementsPanel();
			addElementsPanel.reveal();
		};

		return {
			draggableItems,
			validateItem,
			showElementErrors,
			selectItem,
			isSelectedItem,
			addElementsPanel,
			editElementsPanel,
			closeEditElementsPanel,
			openAddElementsPanel,
			SlideFrom,
			lastEditTime,
			highlights,
			hasUnsavedUpdates,
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
			hasHighlightsAccess,
			areHighlightsEnabledForGroup,
			groupLoadingFailed,
			pageIsLoading,
			submit,
			isSubmitting: submitStatus.isLoading,
			emptySectionsModal,
			confirmSaveModal,
			confirmUnsavedModal,
			confirmIncompleteModal,
			acknowledgeIncompleteElements,
			resetModal,
			isResetting: resetStatus.isLoading,
			selectedItem,
			deleteItem,
			deleteChildModal,
			deleteSectionModal,
			deleteNewChildModal,
			deleteNewSectionModal,
			updateSelection,
			deleteSelection,
			group,
			editState,
			cloneSection,
			cloneElement,
			moveInternal,
			focusClonedItem,
			moveExternal,
			COMPONENTS_BY_TYPE,
			SECTIONS_BY_TYPE,
			ELEMENT_PLACEHOLDERS,
			SECTION_PLACEHOLDERS,
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
